export const searchNavData = [
    {
        id: 1,
        text: 'All',
        icon: 'target',
    },
    {
        id: 2,
        text: 'Images',
        icon: 'image',
    },
    {
        id: 3,
        text: 'Videos',
        icon: 'video-clapper',
    },
    {
        id: 4,
        text: 'Audios',
        icon: 'map-alt',
    },
    {
        id: 5,
        text: 'Settings',
        color: 'bg-light-success',
        textColor: 'text-success'
    },
    {
        id: 6,
        text: 'Tools',
        color: 'bg-light-secondary',
        textColor: 'text-secondary'
    },
];

export const imageTabData = ["01", "02", "03", "04", "05", "011", "010", "08"]